module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ApplyView.js"));
	}, "NameApplyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NameApplyView!./src/pages/Promote/BusinessHall/AlterName/Apply/ApplyView.js
// module id = 1143
// module chunks = 431